import media from "styles/media"
import text from "styles/text"
import styled from "styled-components"
import { checkedLocaleLink } from "utils/routes"
import { useI18next } from "gatsby-plugin-react-i18next"
import UniversalLink from "utils/Loader/UniversalLink"
import colors from "styles/colors"

export default function PopoutLinksCardMobile({
  data,
  translation,
  languageOverride,
}: any) {
  const { language } = useI18next()
  const allLinks = data.links.map((link: any) => {
    const localeLink = checkedLocaleLink(link.url, languageOverride ?? language)
    return (
      <Link className="Header_popout" to={localeLink} key={link.title}>
        {translation[link.title]}
      </Link>
    )
  })
  return (
    <>
      <SubCategoryCard>
        <SubCategoryHeader>{translation[data.title]}</SubCategoryHeader>
        <Links>{allLinks}</Links>
      </SubCategoryCard>
    </>
  )
}

const SubCategoryCard = styled.div`
  width: 42vw;
`
const SubCategoryHeader = styled.h6`
  font-family: "Plain";
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 120%;
  letter-spacing: 0.18em;
  text-transform: capitalize;
  ${media.desktop} {
    font-size: 0.753vw;
  }
  ${media.tablet} {
    font-size: 1.172vw;
  }
  ${media.mobile} {
    font-size: 4vw;
  }
  width: 38vw;
  color: white;
  margin-left: 2.667vw;
  margin-top: 2.5vw;
  overflow-wrap: break-word;
`
const Links = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3vw;
  margin-left: 2.667vw;
`

const Link = styled(UniversalLink)`
  ${text.buttonR}
  font-size: 3.733vw !important;
  width: 40vw;
  color: ${colors.seaFoam400};
  margin-bottom: 1.6vw;
`

const FeaturedProductContainer = styled.div`
  border-radius: 10px;
  display: flex;
  flex-direction: column;
`
const FeaturedProductTitle = styled.h6`
  ${media.fullWidth} {
    margin: 25px;
    margin-top: 20px;
  }
  ${media.tablet} {
    margin: 2.883vw;
    margin-top: 2.441vw;
  }
  margin: 1.512vw;
  margin-top: 1.222vw;
  color: #ffffff;
  ${text.h6}
  font-size: 18px;
  ${media.desktop} {
    font-size: 1.226vw;
  }
  ${media.tablet} {
    font-size: 2.044vw;
  }
  ${media.mobile} {
    font-size: 5.9vw;
  }
`
const FeaturedProductLink = styled.div`
  ${media.fullWidth} {
    margin: 25px;
    margin-top: 0;
  }
  ${media.tablet} {
    margin: 2.883vw;
    margin-top: 0;
  }
  margin: 1.512vw;
  margin-top: 0;
`
